// extracted by mini-css-extract-plugin
export default {"cardContainer":"cardContainer_VyIOl","cardInner":"cardInner_vcC_J","partnerShip":"partnerShip_TEvTl","pagination":"pagination_aD0pK","button":"button_knzAL"};